













































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Home extends Vue {
  get reviewImages () {
    return [
      { src: require('@/assets/review-1.png') },
      { src: require('@/assets/review-2.png') },
      { src: require('@/assets/review-3.png') },
      { src: require('@/assets/review-4.png') },
      { src: require('@/assets/review-5.png') }
    ]
  }

  trackEvent (eventType: string) {
    if(window.wcs && window._nasa) {
      window._nasa["cnv"] = window.wcs.cnv(eventType, "1"); // 전환유형, 전환가치 설정해야함. 설치매뉴얼 참고}
      window.wcs.inflow();
      window.wcs_do(window._nasa);
    }
  }
}
